// DO NOT EDIT THIS FILE BECAUSE IT IS GENERATED AUTOMATICALLY
"use client";

import PropTypes from "prop-types";
import styled from "styled-components";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SVG = styled.svg.withConfig({
  componentId: "sc-176bko1-0"
})(["min-width:", ";max-width:", ";height:", ";"], ({
  $size
}) => $size, ({
  $size
}) => $size, ({
  $size
}) => $size);
const Mail = ({
  size = "1em",
  color = "currentColor",
  title,
  ...props
}) => /*#__PURE__*/_jsxs(SVG, {
  ...props,
  $size: size,
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  role: title ? 'img' : 'presentation',
  children: [title ? /*#__PURE__*/_jsx("title", {
    children: title
  }) : null, " ", /*#__PURE__*/_jsx("path", {
    fill: color,
    d: "M5.217 6.5H18.89l-6.837 6.837L5.217 6.5zM3.5 6.905l8.554 8.553L20.5 7.012V17.5h-17V6.905zM21.008 5H2.992C2.456 5 2 5.451 2 6.007v11.986A.999.999 0 0 0 2.992 19h18.016c.537 0 .992-.451.992-1.007V6.007A.999.999 0 0 0 21.008 5z",
    children: " "
  })]
});
Mail.propTypes = {
  /** The width/height of the icon as any CSS size unit */
  size: PropTypes.string,
  /** The fill color of the icon as any CSS color value */
  color: PropTypes.string,
  /** The title to add as a child of the root svg element */
  title: PropTypes.string
};
export default Mail;